import { Code, CodeType } from '@/types/logs'

export const generateCodeTypeMap = (codes: Code[]): Record<string, CodeType> =>
    codes.reduce<Record<string, CodeType>>((acc, code) => ({ ...acc, [code.code]: code.type }), {})
